import { Renderer2 } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { setAttributes } from './renderer.utils';

let overlayElement: SVGRectElement | null = null;

export const toggleOverlay = (renderer: Renderer2, canvas: SVGSVGElement) => (source: Observable<boolean>) =>
  source.pipe(tap((show) => (show ? createOverlayElement(renderer, canvas) : removeOverlayElement(renderer, canvas))));

export const createOverlayElement = (renderer: Renderer2, canvas: SVGSVGElement) => {
  if (overlayElement || canvas.contains(overlayElement)) {
    return;
  }
  overlayElement = renderer.createElement('rect', 'svg') as SVGRectElement;
  setAttributes(renderer, overlayElement, {
    width: '100%',
    height: '100%',
    stroke: 'none',
    fill: 'transparent',
    x: '0',
    y: '0',
  });

  renderer.appendChild(canvas, overlayElement);
};

export const removeOverlayElement = (renderer: Renderer2, canvas: SVGSVGElement) => {
  if (!overlayElement) {
    return;
  }

  renderer.removeChild(canvas, overlayElement);
  overlayElement = null;
};
